import styled from 'styled-components';

export enum TextTypes {
  Heading1,
  Heading2,
  Heading5,
  BodyXL,
  BodyLG,
  Description,
  ButtonText,
  Plain
}

export const Heading1 = styled.h1`
  font-family: Domaine;
  font-size: 50px;
  font-style: normal;
  font-weight: 500;
  line-height: 55px;
  letter-spacing: -0.01em;
  text-align: center;
`;

export const Heading2 = styled.h2`
  font-family: Domaine;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;

  text-align: center;
`;

export const Heading2Bold = styled(Heading2)`
  font-weight: 600;
`;

export const Heading5 = styled.h3`
  font-family: BrownStd;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 1.5px;
  text-align: center;
`;

export const BodyXL = styled.p`
  font-family: BrownStd;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 33px;

  text-align: center;
`;

export const BodyLG = styled.span`
  font-family: BrownStd;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 150%;
  }
`;

export const BodyMD = styled.span`
  font-family: BrownStd;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 150%;
  }
`;

export const BodyMDBold = styled(BodyMD)`
  font-weight: 700;
`;

export const BodySM = styled.span`
  font-family: BrownStd;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 150%;
  }
`;

export const BodySMBold = styled(BodySM)`
  font-weight: 700;
`;

export const Description = styled.span`
  font-family: BrownStd;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  text-align: center;
`;

export const ButtonText = styled.span`
  text-transform: uppercase;
  font-family: BrownStd;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 1px;
  text-align: center;
`;

export const Superscript = styled.div`
  font-family: 'Domaine';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 110%;
  text-align: center;
`;
